var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickToCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.288,
    height: 30.482,
    viewBox: "0 0 29.288 30.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "click_to_call",
    transform: "translate(-0.492 -0.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8606",
    "data-name": "Path 8606",
    d: "M1.692,256.984a.594.594,0,1,0-.174.426.594.594,0,0,0,.174-.426Zm0,0",
    transform: "translate(0 -241.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8607",
    "data-name": "Path 8607",
    d: "M4.128,14.176a.6.6,0,0,0,.687-.492A13.383,13.383,0,0,1,17.236,2.463l-.2.2a.6.6,0,1,0,.843.843l1.244-1.244a.6.6,0,0,0,0-.843L17.879.175a.6.6,0,0,0-.843.843l.249.249A14.64,14.64,0,0,0,3.636,13.491a.6.6,0,0,0,.492.685Zm0,0",
    transform: "translate(-2.942)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8608",
    "data-name": "Path 8608",
    d: "M354.049,460.5l-.01.006a.6.6,0,0,0,.585,1.039l.01-.006a.6.6,0,0,0-.586-1.039Zm0,0",
    transform: "translate(-332.181 -432.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8609",
    "data-name": "Path 8609",
    d: "M37.483,371.858a13.376,13.376,0,0,1-15.96-5.137l.273.073a.6.6,0,0,0,.309-1.152l-1.7-.455a.6.6,0,0,0-.73.421l-.455,1.7a.6.6,0,1,0,1.152.309l.091-.34a14.641,14.641,0,0,0,17.443,5.7.6.6,0,0,0-.423-1.115Zm0,0",
    transform: "translate(-17.585 -343.398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8610",
    "data-name": "Path 8610",
    d: "M354.133,53.535l.017.01a.6.6,0,0,0,.59-1.036h-.005a.6.6,0,0,0-.6,1.029Zm0,0",
    transform: "translate(-332.275 -49.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8611",
    "data-name": "Path 8611",
    d: "M119.7,138.723a2.086,2.086,0,0,0-2.95,0l-.428.429a.5.5,0,0,1-.7,0l-2.031-2.031a.5.5,0,0,1,0-.7l.428-.429a2.086,2.086,0,0,0,0-2.95l-2.727-2.727a2.086,2.086,0,0,0-2.95,0,6.063,6.063,0,0,0,0,8.575l5.514,5.514a6.07,6.07,0,0,0,8.575,0,2.086,2.086,0,0,0,0-2.95Zm1.884,4.834a4.877,4.877,0,0,1-6.889,0l-5.514-5.514a4.872,4.872,0,0,1,0-6.889.894.894,0,0,1,1.264,0l2.727,2.727a.894.894,0,0,1,0,1.264l-.429.429a1.692,1.692,0,0,0,0,2.39l2.03,2.031a1.69,1.69,0,0,0,2.39,0l.429-.429a.894.894,0,0,1,1.264,0l2.727,2.727a.893.893,0,0,1,0,1.264Zm0,0",
    transform: "translate(-99.736 -121.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8612",
    "data-name": "Path 8612",
    d: "M269.483,120.348a.6.6,0,1,0,0,1.192,5.555,5.555,0,0,1,5.549,5.548.6.6,0,0,0,1.192,0,6.748,6.748,0,0,0-6.741-6.74Zm0,0",
    transform: "translate(-252.388 -113.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8613",
    "data-name": "Path 8613",
    d: "M269.483,180.439a2.04,2.04,0,0,1,2.037,2.037.6.6,0,1,0,1.192,0,3.233,3.233,0,0,0-3.23-3.23.6.6,0,0,0,0,1.192Zm0,0",
    transform: "translate(-252.388 -168.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8614",
    "data-name": "Path 8614",
    d: "M394.1,95.213l-.339.091a14.629,14.629,0,0,0-3.537-17.743.6.6,0,1,0-.774.907,13.437,13.437,0,0,1,3.3,16.2l-.073-.273a.6.6,0,0,0-1.152.309l.455,1.7a.6.6,0,0,0,.73.421l1.7-.455a.6.6,0,1,0-.309-1.152Zm0,0",
    transform: "translate(-365.562 -72.803)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickToCall);
export default __webpack_public_path__ + "static/media/click_to_call.e377c9737d9965a033d4248af9af2b35.svg";
export { ForwardRef as ReactComponent };